import {CONFIRM_CANCELLED} from 'src/pages/scheduleCallback/constants/views';
import {errorStep} from 'src/pages/scheduleCallback/store/actions/errorStep';
import {
  LOAD_INTERACTIONS_ERROR,
  LOAD_INTERACTIONS_SUCCESS,
  loadInteractions,
} from 'src/pages/scheduleCallback/store/actions/interactions';
import {selectIntentStep} from 'src/pages/scheduleCallback/store/actions/selectIntentStep';
import {hasAppointment} from 'src/pages/scheduleCallback/store/selectors/app';
import {fragment} from 'src/pages/scheduleCallback/utils';
import {changeView} from 'src/shared/currentView/actions';
import {logScreenName} from 'src/shared/dataLayer/loggers';
import {waitForNextOneOf} from 'src/shared/events';
import {pushHistory} from 'src/shared/history/actions';

export const cancelAppointmentStep = () => async (dispatch, getState) => {
  if (!hasAppointment(getState())) {
    dispatch(loadInteractions());
    const {type} = await waitForNextOneOf([LOAD_INTERACTIONS_SUCCESS, LOAD_INTERACTIONS_ERROR]);
    if (type === LOAD_INTERACTIONS_ERROR) {
      return dispatch(errorStep());
    }
    if (!hasAppointment(getState())) {
      return dispatch(selectIntentStep());
    }
  }

  dispatch(pushHistory(cancelAppointmentStep(), fragment('cancel')));
  dispatch(changeView(CONFIRM_CANCELLED));
  logScreenName('cancelcallback');
};
